import { create } from 'zustand';

interface AudioLevelState {
  inputLevel: number;
  outputLevel: number;
  setInputLevel: (level: number) => void;
  setOutputLevel: (level: number) => void;
  reset: () => void;
}

const useAudioLevelStore = create<AudioLevelState>((set) => ({
  inputLevel: 0,
  outputLevel: 0,
  setInputLevel: (level) => set({ inputLevel: level }),
  setOutputLevel: (level) => set({ outputLevel: level }),
  reset: () => set({ inputLevel: 0, outputLevel: 0 }),
}));

export default useAudioLevelStore;
